import styled from 'styled-components';
import { Checkbox, Input, Select } from 'antd';
import { Link } from 'react-router-dom';
import ButtonComponent from 'component/button_components';

//Logo
export const LoginBackImage = styled.div`
  background-image: ${(props) =>
    props.backgroundimage
      ? props.showBackImage
        ? `url(${props.backgroundimage})`
        : 'none'
      : getComputedStyle(document.documentElement).getPropertyValue('--show-background-image').trim() === 'true'
      ? `var(--bg-login-background-image)`
      : 'none'};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'var(--bg-login-background-color)')};
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;
export const PartialWrapLoginBackImage = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: 60% 40%;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'var(--bg-login-background-color)')};
  @media screen and (max-width: 1024px) {
    grid-template-columns: 0% 100%;
  }
  &.mornglow {
    grid-template-columns: 40% 60%;
    @media screen and (max-width: 1024px) {
      grid-template-columns: 100% 0%;
    }
    .column {
      @media screen and (max-width: 1024px) {
        display: flex;
        justify-content: center;
        .leftsideLogo {
          padding-left: 0px;
        }
        .logoleft {
          align-items: center;
        }
      }
    }
  }
`;
//Wrap
export const Wrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &.logoleft {
    flex-direction: column;
    align-items: flex-start;
    justify-content: unset;
  }
`;

//LoginWraper
export const LoginWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  &.mornglow {
    margin-bottom: 80px;
    @media screen and (max-width: 1024px) {
      justify-content: center;
      margin-right: 0px;
    }
  }
  &.nitrate {
    justify-content: center;
    width: 460px;
    height: auto;
    border: 1px solid #707070;
    border-radius: 15px;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.16);
    background: #252f48;
  }
`;

//LoginContainer
export const LoginContainer = styled.div`
  width: 400px;
  height: auto;
  padding: 2em;
  &.block_container {
    display: block;
  }
`;

//Logo
export const Logo = styled.img`
  margin-bottom: 30px;
  content: var(--img-login-logo);
  &.leftsideLogo {
    padding-left: 28px;
    margin: 30px;
    max-width: 250px;
    max-height: 80px;
  }
`;

export const InputWrap = styled.div`
  margin: 0px 30px 0px 30px;
  .globlue {
    .icon-color {
      color: #fff;
    }
    &.remember_color {
      color: #fff;
    }
  }
  .mornglow {
    .icon-color {
      color: #91a3af;
    }
    .remember_color {
      color: #91a3af;
    }
  }
  .teamring {
    .icon-color {
      color: #3e4f60;
    }
    .remember_color {
      color: #3e4f60;
    }
  }
  .nitrate {
    .icon-color {
      color: #fff;
    }
    .remember_color {
      color: #fff;
    }
  }
`;

export const LogoWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const RememberMe = styled(Checkbox)`
  &.globlue {
    color: #fff;
  }
  &.nitrate {
    color: #fff;
  }
  &.mornglow {
    color: #1785d6;
  }
  &.teamring {
    color: #004881;
  }
`;

//InputSelect
export const StyledSelectInput = styled(Select)`
  .ant-select-single .ant-select-selector {
    border: 1px solid #33455d;
    color: #fff;
  }
  .ant-select-single:focus .ant-select-selector {
    color: #000 !important;
  }
  .ant-select-arrow,
  .ant-select-item-option-content,
  .ant-select-selection-placeholder {
    color: #fff;
  }
  &.ant-select-single {
    .ant-select-selector {
      border: 1px solid #33455d;
      color: #fff;
    }
  }
  &.globlue {
    &.ant-select-single .ant-select-selector {
      background-color: #33455d;
    }
    &.ant-select-single {
      .ant-select-selector {
        background-color: #33455d;
      }
    }
  }
  &.mornglow {
    .ant-select-single .ant-select-selector {
      border: 1px solid #c2d2e3;
      color: #91a3af;
    }

    .ant-select-single:focus .ant-select-selector {
      color: #000 !important;
    }

    .ant-select-arrow,
    .ant-select-item-option-content,
    .ant-select-selection-placeholder {
      color: #91a3af;
    }
    &.ant-select-single {
      .ant-select-selector {
        border: 1px solid #c2d2e3;
        color: #91a3af;
        border-radius: 20px;
      }
    }
  }
  &.nitrate {
    .ant-select-single .ant-select-selector {
      border: 1px solid #c2d2e3;
      color: #91a3af;
    }
    .ant-select-selection-item {
      margin-top: 4px;
    }
    .ant-select-single:focus .ant-select-selector {
      color: #000 !important;
    }

    .ant-select-arrow,
    .ant-select-item-option-content,
    .ant-select-selection-placeholder {
      color: #fff;
    }
    .ant-select-selection-placeholder {
      margin-top: 4px;
    }
    &.ant-select-single {
      .ant-select-selector {
        color: #fff;
        height: 50px !important;
        border-radius: 25px;
        border: 1px solid #435059;
        background: inherit;
      }
    }
  }
  &.teamring {
    .ant-select-single .ant-select-selector {
      border: 1px solid #3e4f60;
      color: #3e4f60;
    }
    .ant-select-selection-item {
      margin-top: 4px;
    }
    .ant-select-single:focus .ant-select-selector {
      color: #000 !important;
    }
    .ant-select-arrow,
    .ant-select-item-option-content,
    .ant-select-selection-placeholder {
      color: #3e4f60;
    }
    .ant-select-selection-placeholder {
      margin-top: 4px;
    }
    &.ant-select-single {
      .ant-select-selector {
        border: 1px solid #c2d2e3;
        color: #3e4f60;
        box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.16);
        height: 50px !important;
        border-radius: 5px;
      }
    }
  }
`;

//InputComponent
export const StyledInput = styled(Input)`
  ::placeholder {
    color: #fff;
  }
  border: 1px solid #33455d;
  background-color: #33455d;

  /* AntD 5.x input targeting */
  input {
    color: #fff !important;
    background-color: transparent !important;
    -webkit-text-fill-color: #fff !important;
  }
  input::placeholder {
    color: rgba(255,255,255,0.6) !important;
  }
  & > .ant-input {
    background-color: inherit;
    color: #fff;
  }
  &.globlue {
    background-color: #33455d;
  }
  &.mornglow {
    ::placeholder {
      color: #91a3af;
    }
    border: 1px solid #c2d2e3;
    border-radius: 20px;
    background-color: #fff;
    input {
      color: #91a3af !important;
      background-color: transparent !important;
      -webkit-text-fill-color: #91a3af !important;
    }
    & > .ant-input {
      background-color: #fff;
      color: #91a3af;
    }
  }
  &.nitrate {
    height: 50px !important;
    border-radius: 25px;
    border: 1px solid #435059;
    background: inherit !important;
  }
  &.teamring {
    ::placeholder {
      color: #3e4f60;
    }
    border: 1px solid #c2d2e3;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    height: 50px !important;
    background-color: #fff;
    input {
      color: #3e4f60 !important;
      background-color: transparent !important;
      -webkit-text-fill-color: #3e4f60 !important;
    }
    & > .ant-input {
      background-color: #fff;
      color: #3e4f60;
    }
  }
`;

//Inputpassword
export const StyledInputPassword = styled(Input.Password)`
  ::placeholder {
    color: #fff;
  }
  border: 1px solid #33455d;
  background-color: #33455d;

  /* AntD 5.x password input targeting */
  input {
    color: #fff !important;
    background-color: transparent !important;
    -webkit-text-fill-color: #fff !important;
  }
  input::placeholder {
    color: rgba(255,255,255,0.6) !important;
  }
  .anticon-eye, .anticon-eye-invisible {
    color: #fff !important;
    opacity: 1 !important;
  }
  .ant-input-suffix {
    opacity: 1 !important;
    visibility: visible !important;
    svg {
      color: #fff !important;
    }
  }
  & > .ant-input-suffix {
    svg {
      color: #fff;
    }
  }
  & > .ant-input {
    background-color: inherit;
    color: #fff;
  }
  &.mornglow {
    ::placeholder {
      color: #91a3af;
    }
    border: 1px solid #c2d2e3;
    border-radius: 20px;
    background-color: #fff;
    input {
      color: #91a3af !important;
      -webkit-text-fill-color: #91a3af !important;
      background-color: transparent !important;
    }
    .anticon-eye, .anticon-eye-invisible { color: #91a3af !important; }
    & > .ant-input-suffix { svg { color: #91a3af; } }
    & > .ant-input { background-color: #fff; color: #91a3af; }
  }
  &.nitrate {
    height: 50px !important;
    border-radius: 25px;
    border: 1px solid #435059;
    background: inherit;
  }
  &.teamring {
    ::placeholder { color: #3e4f60; }
    border: 1px solid #c2d2e3;
    border-radius: 5px;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.16);
    height: 50px !important;
    background-color: #fff;
    input {
      color: #3e4f60 !important;
      -webkit-text-fill-color: #3e4f60 !important;
      background-color: transparent !important;
    }
    .anticon-eye, .anticon-eye-invisible { color: #3e4f60 !important; }
    & > .ant-input-suffix { svg { color: #3e4f60; } }
    & > .ant-input { color: #3e4f60; }
  }
`;

export const ForgotPasswordItem = styled.div`
  font-size: 15px;
  margin-top: -10px;
  text-align: end;
  ${({ disabled }) =>
    disabled &&
    `pointer-events: none;
  `}
`;
//ColumnContainer
export const ColumnContainer = styled.section`
  display: flex;
  height: 100%;
  .column {
    flex: 1;
    width: 100%;
  }
  &.nitrate {
    justify-content: center;
  }
  &.teamring {
    justify-content: center;
    align-items: center;
  }

  &.globlue {
    @media screen and (max-width: 1024px) {
      .column:first-child {
        display: none;
      }
    }
  }
`;

//link
export const StyledLink = styled(Link)`
  color: #fff;
  display: block;
  &.mornglow {
    color: #1785d6;
  }
  &.teamring {
    color: #004881;
  }
`;

//Heading
export const Heading = styled.p`
  background-color: inherit;
  margin-top: auto;
  font-size: 25px;
  color: var(--white-color);

  &.globlue {
    text-align: center;
  }
  &.nitrate {
    text-align: center;
  }
  &.mornglow {
    font-size: 30px;
    color: #3e4f60;
    margin-left: 28px;
  }
  &.teamring {
    font-size: 30px;
    color: #3e4f60;
    margin-left: 28px;
  }
`;

//SelectWrapper
export const SelectWrapper = styled.div`
  position: relative;

  .prefix-icon-wrapper {
    position: absolute;
    z-index: 1;
    width: 3rem;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-color {
    color: #fff;
  }

  && .ant-select .ant-select-selector {
    padding-left: calc(3rem - 8px);
  }
  &.nitrate {
    .prefix-icon-wrapper {
      height: 50px;
    }
  }
  &.mornglow {
    .icon-color {
      color: #3e4f60;
    }
  }
  &.teamring {
    .prefix-icon-wrapper {
      height: 50px;
    }
    .icon-color {
      color: #3e4f60;
    }
  }
`;

//LoginButton
export const ThemeLoginButton = styled(ButtonComponent)`
  color: ${(props) => (props.buttonTextColor ? props.buttonTextColor : 'var(--login-button-text-color)')};
  background: ${(props) => (props.buttonColor ? props.buttonColor : ' var(--bg-login-button-color)')};
  border: var(--bg-login-button-color);
  &.mornglow {
    border-radius: 25px;
  }
  &.nitrate {
    border-radius: 25px;
    height: 50px;
  }
  &.teamring {
    height: 50px;
    border-radius: 5px;
    font-size: 20px;
  }
`;
